import { useQuery } from '@tanstack/react-query';
import { extractBackendErrorCode } from '@/core/api/http-errors';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';

/** Validates a per-recipient share token and reads the form schema — no auth/tenant context. */
export function useFormByAccessToken(token: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: FORM_KEYS.accessByToken(token),
    queryFn: ({ signal }) => formsService.getByAccessToken(token, signal),
    staleTime: 60_000,
    enabled: !!token,
    retry: 1,
  });

  return {
    form: data?.data,
    isLoading,
    isError,
    errorCode: isError ? extractBackendErrorCode(error) : null,
  };
}
